<template>
  <div class="container" style="margin-bottom: 10px">
    <div class="card" style="padding: 16px">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <div class="meta-logo-wrap">
            <i class="fab fa-whatsapp meta-logo-icon"></i>
          </div>
          <div>
            <h5 style="margin: 0">Meta — prueba de plantilla WhatsApp</h5>
            <p style="margin: 0; font-size: 12px; color: #7c7c7c">
              Envío vía <code>consultasV2</code> (<code>/testing/Meta/SendTemplate</code>). Las
              credenciales quedan en el servidor (Graph API). Teléfonos: código de país, solo
              dígitos, sin <code>+</code> (se normalizan al enviar).
            </p>
          </div>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <button class="btn btn-outline-secondary btn-sm" type="button" @click="resetForm">
            Reset
          </button>
          <button class="btn btn-success btn-sm" type="button" :disabled="sending" @click="onEnviar">
            {{ sending ? "Enviando..." : "Enviar" }}
          </button>
        </div>
      </div>

      <hr style="margin: 12px 0" />

      <div class="row">
        <div class="col-12 col-md-6">
          <label class="form-label">URL del endpoint (opcional)</label>
          <input
            v-model="endpointUrl"
            class="form-control"
            type="text"
            autocomplete="off"
            :placeholder="defaultProxyPlaceholder"
          />
          <small style="color: #7c7c7c">
            Vacío = mismo host que el resto de la app (emulador o prod).
          </small>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">languageCode</label>
          <input
            v-model="form.languageCode"
            class="form-control"
            type="text"
            placeholder="es"
          />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">headerParameter</label>
          <input
            v-model.trim="form.headerParameter"
            class="form-control"
            type="text"
            autocomplete="off"
            placeholder="Opcional (variable del header)"
          />
        </div>
      </div>

      <div class="row" style="margin-top: 4px">
        <div class="col-12 col-md-6">
          <label class="form-label">templateName <span class="text-danger">*</span></label>
          <input
            v-model.trim="form.templateName"
            class="form-control"
            type="text"
            autocomplete="off"
            placeholder="Nombre exacto de la plantilla en Meta"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">Destinos (teléfonos WhatsApp) <span class="text-danger">*</span></label>
          <textarea
            v-model="destinationsRaw"
            class="form-control"
            rows="3"
            spellcheck="false"
            placeholder="Uno por línea o coma. Ej: 5939XXXXXXXX o +593 9X XX XX XX (se quita + y espacios)"
          />
        </div>
      </div>

      <div class="row" style="margin-top: 12px">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <h6 style="margin: 0">bodyParameters</h6>
            <button class="btn btn-outline-primary btn-sm" type="button" @click="addParam">
              + Agregar
            </button>
          </div>
          <p style="margin: 6px 0 0 0; font-size: 12px; color: #7c7c7c">
            Valores de las variables del body en orden
            (<code v-pre>{{1}}</code>, <code v-pre>{{2}}</code>, …
            ({{ form.bodyParameters.length }} ítem(s)).
          </p>
          <div
            v-for="(p, idx) in form.bodyParameters"
            :key="`bp-${idx}`"
            class="row align-items-center"
            style="margin-top: 8px"
          >
            <div class="col">
              <input
                v-model="form.bodyParameters[idx]"
                class="form-control"
                type="text"
                :placeholder="`Parámetro ${idx + 1}`"
              />
            </div>
            <div class="col-auto">
              <button
                class="btn btn-outline-danger btn-sm"
                type="button"
                title="Quitar"
                @click="removeParam(idx)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
          <div
            v-if="form.bodyParameters.length === 0"
            class="text-muted"
            style="margin-top: 8px; font-size: 13px"
          >
            Sin parámetros (vacío se envía como <code>[]</code>).
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 16px">
        <div class="col-12">
          <label class="form-label">Payload (JSON)</label>
          <textarea
            class="form-control"
            :value="payloadPreview"
            rows="10"
            readonly
            spellcheck="false"
          />
        </div>
      </div>

      <div v-if="lastResult" style="margin-top: 12px">
        <small style="color: #7c7c7c">Última respuesta</small>
        <div class="card" style="padding: 10px; border: 1px solid #eee; margin-top: 6px">
          <div class="d-flex gap-2 flex-wrap">
            <span class="badge" :class="lastResult.ok ? 'bg-success' : 'bg-danger'">
              {{ lastResult.ok ? "OK" : "ERROR" }}
            </span>
            <span class="badge bg-secondary">HTTP {{ lastResult.status }}</span>
          </div>
          <pre
            style="margin: 8px 0 0 0; white-space: pre-wrap; word-break: break-word"
          >{{ lastResult.body }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getConsultasApiV1BaseURL } from "@/store/axios";

export default {
  name: "MetaAdmin",
  data() {
    return {
      endpointUrl: "",
      destinationsRaw: "",
      form: this.getDefaultForm(),
      payloadPreview: "",
      sending: false,
      lastResult: null,
    };
  },
  computed: {
    defaultMetaUrl() {
      const base = getConsultasApiV1BaseURL();
      const normalized = base.endsWith("/") ? base : `${base}/`;
      return `${normalized}testing/Meta/SendTemplate`;
    },
    defaultProxyPlaceholder() {
      return `Vacío → ${this.defaultMetaUrl}`;
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.refreshPayloadPreview();
      },
    },
    destinationsRaw() {
      this.refreshPayloadPreview();
    },
  },
  mounted() {
    this.refreshPayloadPreview();
  },
  methods: {
    getDefaultForm() {
      return {
        templateName: "",
        languageCode: "es",
        headerParameter: "",
        bodyParameters: [],
      };
    },
    parseDestinations(raw) {
      const s = String(raw || "").trim();
      if (!s) return [];
      const byComma = s.includes(",") && !s.includes("\n");
      if (byComma) {
        return s
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean);
      }
      return s
        .split(/\r?\n/)
        .map((x) => x.trim())
        .filter(Boolean);
    },
    /** Same rules as JelouAdmin / backend: country code, no +, digits only. */
    normalizeDestination(raw) {
      const trimmed = String(raw ?? "").trim();
      if (!trimmed) return "";
      const withoutPlus = trimmed.startsWith("+") ? trimmed.slice(1) : trimmed;
      return withoutPlus.replace(/\D/g, "");
    },
    buildPayload() {
      const destinations = this.parseDestinations(this.destinationsRaw)
        .map((d) => this.normalizeDestination(d))
        .filter((d) => d.length > 0);
      const bodyParameters = (this.form.bodyParameters || [])
        .map((x) => String(x ?? "").trim())
        .filter((x) => x.length > 0);

      const payload = {
        templateName: String(this.form.templateName || "").trim(),
        languageCode: String(this.form.languageCode || "es").trim() || "es",
        destinations,
        bodyParameters,
      };

      const headerParameter = String(this.form.headerParameter || "").trim();
      if (headerParameter) payload.headerParameter = headerParameter;

      return payload;
    },
    refreshPayloadPreview() {
      try {
        this.payloadPreview = JSON.stringify(this.buildPayload(), null, 2);
      } catch (e) {
        this.payloadPreview = "";
      }
    },
    resetForm() {
      this.form = this.getDefaultForm();
      this.destinationsRaw = "";
      this.endpointUrl = "";
      this.lastResult = null;
      this.refreshPayloadPreview();
    },
    addParam() {
      this.form.bodyParameters.push("");
    },
    removeParam(idx) {
      this.form.bodyParameters.splice(idx, 1);
    },
    async onEnviar() {
      if (this.sending) return;

      const payload = this.buildPayload();
      this.payloadPreview = JSON.stringify(payload, null, 2);

      if (!payload.templateName) {
        if (this.$toast) {
          this.$toast.warning("Indica templateName.", { position: "top-right", max: 3 });
        }
        return;
      }
      if (!payload.destinations.length) {
        if (this.$toast) {
          this.$toast.warning("Indica al menos un destino.", { position: "top-right", max: 3 });
        }
        return;
      }

      const url = (this.endpointUrl || "").trim() || this.defaultMetaUrl;

      this.sending = true;
      this.lastResult = null;
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const text = await res.text();
        let body = text;
        try {
          body = JSON.stringify(JSON.parse(text), null, 2);
        } catch (_) {
          /* no JSON */
        }
        this.lastResult = { ok: res.ok, status: res.status, body };

        if (this.$toast) {
          if (res.ok) {
            this.$toast.success("Solicitud enviada. Revisa la respuesta abajo.", {
              position: "top-right",
              max: 3,
            });
          } else {
            this.$toast.error(`Error HTTP ${res.status}. Revisa la respuesta abajo.`, {
              position: "top-right",
              max: 3,
            });
          }
        }
      } catch (e) {
        this.lastResult = {
          ok: false,
          status: 0,
          body: e?.message || String(e),
        };
        if (this.$toast) {
          this.$toast.error("No se pudo enviar (red/CORS).", { position: "top-right", max: 3 });
        }
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
.form-label {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
}
.meta-logo-wrap {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.meta-logo-icon {
  color: #fff;
  font-size: 28px;
  line-height: 1;
}
</style>
